<template>
    <div
        class="product-description
            max-w-3xl
            product-options
            z-10 bg-white pl-16 pr-8 pt-12
            phone:-mt-10
            mobile:self-center mobile:mx-4
            tablet:-mt-2 tablet:pl-24 tablet:px-12 tablet:pt-24
            tabletLandscape:mt-0 tabletLandscape:min-h-screen tabletLandscape:px-8 tabletLandscape:pl-16 tabletLandscape:pt-8
            desktop:pt-18"
    >
        <h3
            class="uppercase mb-6 text-xl tablet:text-2xl font-regular text-gray-800"
            v-html="getCurrentProductDescriptionProperty('productTitle')"
        />
        <p
            class="text-gray-700 text-sm tablet:text-lg tabletLandscape:text-sm desktop:text-md hd:text-lg leading-relaxed mb-8"
            v-html="getCurrentProductDescriptionProperty('productContent')"
        />

        <div
            v-for="(option, optionIndex) in Object.values(getCurrentProductDescriptionProperty('productOptions', {}))"
            :key="optionIndex"
            class="product-options"
            @click="setActiveAccordionPane(optionIndex)"
        >
            <hr class="text-gold-500 mb-6 first:hidden tablet:max-w-tiny">
            <h4
                class="option-item uppercase mb-4 relative tablet:text-xl"
                :class="{
                    'active': currentProductAccordionIndex === optionIndex,
                    'cursor-pointer': currentProductAccordionIndex !== optionIndex && ! isHdWidth
                }"
            >
                <span class="feature-index hidden hd:block absolute text-gray-800 opacity-5 font-bold">
                    {{ optionIndex + 1 }}
                </span>
                <span
                    class="text-gold-500 font-bold"
                    :class="{'cursor-pointer': currentProductAccordionIndex !== optionIndex && ! isHdWidth}"
                >
                    {{ option.label }}:
                </span>
                <span
                    class="text-gray-800 font-bold"
                    :class="{'cursor-pointer': currentProductAccordionIndex !==optionIndex && ! isHdWidth}"
                >
                    {{ option.subHeader }}
                </span>
                <div
                    v-if="option.optionSubTitle"
                    class="text-gray-500 text-xs">
                    {{ option.optionSubTitle }}
                </div>
            </h4>
            <ul
                class="features pl-4 list-square transition-all overflow-hidden"
                :class="{
                    'active my-6': currentProductAccordionIndex === optionIndex,
                    'hidden' : ! isHdWidth && currentProductAccordionIndex !== optionIndex
                }"
            >
                <li
                    v-for="(feature, featureIndex) in option.features"
                    :key="featureIndex"
                    class="text-sm text-gold-500 mb-2"
                >
                    <span class="text-gray-800">{{ feature }}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { get } from 'lodash';

export default {
  name: 'GalleryProductDescriptions',
  components: {},
  props: {
    products: {
      type: Object,
      required: true,
    },
    currentProductSlug: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    currentWindowWidth: window.innerWidth,
    currentProductAccordionIndex: 0,
  }),

  computed: {
    isHdWidth() {
      return this.currentWindowWidth >= 1920;
    },
  },

  created() {
    window.addEventListener('resize', this.handleWindowResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize);
  },

  methods: {
    handleWindowResize() {
      this.currentWindowWidth = window.innerWidth;
    },
    getCurrentProductDescriptionProperty(property, defaultValue) {
      return get(this.products, [this.currentProductSlug, 'productDescription', property], defaultValue);
    },
    setActiveAccordionPane(optionIndex) {
      if (this.isHdWidth) {
        return;
      }

      if (this.currentProductAccordionIndex === optionIndex) {
        return this.currentProductAccordionIndex = null;
      }
      this.currentProductAccordionIndex = optionIndex;
    },
  },
};
</script>

<style lang="scss" scoped>
.product-description {
    @screen tablet {
        width: 80%;
    }

    @screen tabletLandscape {
        width: 40%
    }

    @screen desktop {
        width: 100%
    }

}

.product-options {
    .feature-index {
        @screen desktop {
            font-size: 75px;
            top: -65px;
            left: -6px;
        }
        @screen hd {
            font-size: 100px;
            top: -77px;
            left: -6px;
        }

    }

    @screen phone {
        &:first-of-type {
            hr {
                @apply hidden;
            }
        }
    }

    @screen hd {
        .option-item {
            &:before,
            &.active:before {
                @apply hidden border-0;
            }
        }
    }
}
</style>
